import type { SyncImageAdapter } from "@reciperoll/core";

// Web has no local file picks or offline file cache yet: remote image URLs are
// rendered directly and cached by the browser, so both image steps are no-ops.
// When web image upload is added, implement uploadPendingImages to push picked
// File/Blobs to Storage (mirroring the RN adapter) and stamp the public URL.
export const webImages: SyncImageAdapter = {
  async uploadPendingImages() {
    return 0;
  },
  async cacheRemoteImages() {
    /* browser caches remote URLs */
  },
};
